const quantityButtonHandler = (button, input) => {
  const modifier = parseInt(button.dataset.modifier) || 1
  const value = parseInt(input.value)
  const newValue = value + modifier
  if (newValue > 0) {
    input.value = newValue
  }
}

document.querySelectorAll('.product-qty').forEach((root) => {
  const input = root.querySelector('input')
  root.addEventListener('click', (event) => {
    const isButton = event.target.closest('button')
    if (isButton) {
      quantityButtonHandler(isButton, input)
    }
  })
})
